export default __webpack_public_path__ + "static/bestview-grounds1-thumb-786051736ab99628723c7a411c5b105c.jpg";